import React from 'react';
import './PayoutTableSkeleton.css';

const PayoutTableSkeleton = () => {
  return (
    <div className="payout-table-skeleton-wrapper">
      <table className="payout-table-skeleton">
        <thead>
          <tr>
            <th className="payout-skeleton-th">
              <div className="payout-skeleton-header" />
            </th>
            <th className="payout-skeleton-th">
              <div className="payout-skeleton-header" />
            </th>
            <th className="payout-skeleton-th">
              <div className="payout-skeleton-header" />
            </th>
            <th className="payout-skeleton-th">
              <div className="payout-skeleton-header" />
            </th>
            <th className="payout-skeleton-th">
              <div className="payout-skeleton-header" />
            </th>
            <th className="payout-skeleton-th">
              <div className="payout-skeleton-header" />
            </th>
            <th className="payout-skeleton-th">
              <div className="payout-skeleton-header" />
            </th>
            <th className="payout-skeleton-th">
              <div className="payout-skeleton-header" />
            </th>
          </tr>
        </thead>
        <tbody>
          {[...Array(8)].map((_, index) => (
            <tr key={index} className="payout-skeleton-row">
              <td>
                <div className="payout-skeleton-cell-long" />
              </td>
              <td>
                <div className="payout-skeleton-cell" />
              </td>
              <td>
                <div className="payout-skeleton-cell" />
              </td>
              <td>
                <div className="payout-skeleton-cell" />
              </td>
              <td>
                <div className="payout-skeleton-cell" />
              </td>
              <td>
                <div className="payout-skeleton-cell" />
              </td>
              <td>
                <div className="payout-skeleton-cell" />
              </td>
              <td>
                <div className="payout-skeleton-badge" />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default PayoutTableSkeleton;
